import React from 'react';
import { TablePagination } from '@mui/material';

interface CustomTablePaginationProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CustomTablePagination: React.FC<CustomTablePaginationProps> = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) => {
  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      onPageChange={onPageChange}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={onRowsPerPageChange}
      rowsPerPageOptions={[5, 10, 25, 50]}
      sx={{
        '& .MuiTablePagination-select': {
          backgroundColor: '#09BBE9',
          color: '#fff',
          borderRadius: '8px',
          padding: '6px 10px',
          border: 'transparent'
        },
        '& .MuiTablePagination-selectIcon': {
          color: '#fff'
        }
      }}
    />
  );
};